// Components/HomePage/WhyUsSection.jsx
import React from "react";
import { FiTool, FiCheckCircle, FiHome } from "react-icons/fi";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

export default function WhyUsSection() {
  const reasons = [
    {
      icon: <FiTool className="text-[#f8f9fa] w-6 h-6" />,
      title: "Third-Generation Expertise",
      desc: "Rooted in the trades with deep respect for proper construction methods and craftsmanship that lasts.",
    },
    {
      icon: <FiCheckCircle className="text-[#f8f9fa] w-6 h-6" />,
      title: "Built on Integrity",
      desc: "No shortcuts, no corner cutting. We build like it's our own home because your trust matters.",
    },
    {
      icon: <FiHome className="text-[#f8f9fa] w-6 h-6" />,
      title: "Craftsmanship & Accountability",
      desc: "We handle everything A–Z. No subcontractor surprises. One team, one responsibility.",
    },
  ];

  return (
    <section className="relative py-10 md:py-14 px-4 md:px-8 bg-[#212529] flex flex-col items-center justify-center
      before:absolute before:inset-0 before:-z-10 before:rounded-xl before:shadow-[0_0_80px_rgba(173,181,189,0.2)]">
      <div className="relative w-full max-w-5xl mx-auto text-center">

        {/* Section Heading */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
          variants={staggerContainer}
          className="mb-8"
        >
          <motion.h2
            variants={fadeUp}
            className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-white"
          >
            Why Choose Ashlar Building Group?
          </motion.h2>
          <motion.p
            variants={fadeUp}
            className="text-white/80 text-sm sm:text-base max-w-2xl mx-auto leading-relaxed"
          >
            We exist to protect homeowners, families, and investors from bad construction experiences. Here's why clients trust us to bring their projects to life.
          </motion.p>
        </motion.div>

        {/* Reasons Grid */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
        >
          {reasons.map((reason, idx) => (
            <motion.div
              key={idx}
              variants={fadeUp}
              className="w-full p-5 bg-[#e9ecef] border border-[#dee2e6] rounded-lg shadow-md
                         transition-all duration-500 transform hover:scale-105 flex flex-col items-center text-center
                         hover:shadow-[0_0_25px_rgba(173,181,189,0.4)]"
            >
              {/* Icon in dark circle */}
              <div className="w-14 h-14 mb-3 rounded-full bg-[#343a40] flex items-center justify-center flex-shrink-0">
                {reason.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-1 text-[#212529]">{reason.title}</h3>
              <p className="text-[#6c757d] text-sm leading-relaxed">{reason.desc}</p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}